import React from 'react';
import { StyledTable } from './styles';
import { SpaceProps, LayoutProps, TypographyProps, ColorProps, BorderProps, PositionProps } from 'styled-system';

type TableSystemProps = SpaceProps & LayoutProps & TypographyProps & ColorProps & BorderProps & PositionProps;

export type TableProps = React.TableHTMLAttributes<HTMLTableElement> &
    TableSystemProps & {
        striped?: boolean;
        className?: string;
    };

const Table: React.FC<TableProps> = ({ className, ...props }) => {
    const cls = className ? `rui-table ${className}` : 'rui-table';
    return <StyledTable className={cls} {...props} />;
};

Table.defaultProps = { striped: true };

export default Table;
